import { useHookstate } from '@hookstate/core';
import { Auth, I18n } from 'aws-amplify';
import { Button } from "primereact/button";
import { InputText } from 'primereact/inputtext';
import { TabPanel, TabView } from 'primereact/tabview';
import { Dropdown } from "primereact/dropdown";
import classNames from "classnames";
import React, { useContext, useEffect, useState } from 'react';
import { updateMyProfile } from '../../service/CdmGlobalService.js';
import { StructureContext } from '../../structure-context';
import { useGroupMember } from '../../user-context';
import { globalBlockedState, ToastContext } from '../../app-context';
import { useGlobalHelpState } from '../../help-context';
import { Team } from './Team';
import { isEmail, checkPhoneNumber } from '../../Utils';
import { Help } from '../help/Help.js';

export const Profile = () => {
    const structureContext = useContext(StructureContext);
    const [mailInUse, setMailInUse] = useState(false);
    const localUserState = useHookstate({});
    const toast = useContext(ToastContext);
    const blockedState = useHookstate(globalBlockedState);
    const helpState = useGlobalHelpState();
    const [activeIndex, setActiveIndex] = useState(0);

    if (!localUserState.get().Username) {
        Auth.currentAuthenticatedUser({
            bypassCache: false
        })
            .then(user => {
                localUserState.set({ ...user.attributes, Username: user.username });
            })
            .catch(err => console.log(err));
    }

    useEffect(() => {
        helpState.set({ show: false, help: Help.global })
        //eslint-disable-next-line
    }, [])

    const checkMail = () => {
        const _mail = localUserState.get().email ?? '';
        return !(isEmail(_mail));
    }

    const onChange = (event) => {
        localUserState[event.target.name].set(event.target.value);
    };

    const handleSubmit = async event => {
        event.preventDefault();
        blockedState.set(true);
        updateMyProfile(structureContext.id, localUserState.get(), refreshUserState);
    };

    const refreshUserState = (error) => {
        if (!error) {
            Auth.currentAuthenticatedUser({
                bypassCache: true
            })
                .then(user => {
                    blockedState.set(false);
                    setMailInUse(false);
                    if (I18n.get('currentlanguage') !== user.attributes.locale.toLowerCase()) {
                        I18n.setLanguage(user.attributes.locale.toLowerCase());
                        window.location.reload();
                    }
                    localUserState.set({ ...user.attributes, Username: user.username });
                })
                .catch(err => console.log(err));
        } else if (error.response.status === 409) {
            blockedState.set(false);
            setMailInUse(true);
        } else {
            blockedState.set(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000, closable: false });
        }
    }

    const tabHeaderTeam = (options) => {
        return (
            <button type="button" onClick={options.onClick} className={options.className}>
                <i className="pi pi-users cdm-icon-tab" />
                {options.titleElement}
                {<i className="pi pi-info-circle ml-2" onClick={() => { helpState.set({ show: true, help: Help.team }) }} />}
            </button>
        );

    };

    const onTabChange = (e) => {
        setActiveIndex(e.index);
        if (e.index === 0) {
            helpState.set({ show: false, help: Help.global })
        }
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <div className="col-12 sm:col-12 md:col-12 lg:col-12">
                        <h5>{localUserState.get().given_name} {localUserState.get().family_name}</h5>
                        <TabView activeIndex={activeIndex} onTabChange={onTabChange}>
                            <TabPanel header={I18n.get("Informations personnelles")} leftIcon="pi pi-user cdm-icon-tab">
                                <div className="grid">
                                    <div className="col-12">
                                        <span className="p-float-label cdm-float-label">
                                            <InputText id="username" type="text" value={localUserState.get().Username || ""} disabled size={25} />
                                            <label htmlFor="username">{I18n.get("Nom d'utilisateur")}</label>
                                        </span>
                                    </div>
                                    <div className="col-12">
                                        <span className="p-float-label cdm-float-label">
                                            <InputText id="family_name" name="family_name" value={localUserState.get().family_name || ""} onChange={(e) => onChange(e)} required className={classNames({
                                                "cdm-field-error": !localUserState.get().family_name,
                                            })} />
                                            <label htmlFor="family_name">{I18n.get("Nom")}</label>
                                        </span>
                                    </div>
                                    <div className="col-12">
                                        <span className="p-float-label cdm-float-label">
                                            <InputText id="given_name" name="given_name" value={localUserState.get().given_name || ""} onChange={(e) => onChange(e)} required className={classNames({
                                                "cdm-field-error": !localUserState.get().given_name,
                                            })} />
                                            <label htmlFor="given_name">{I18n.get("Prénom")}</label>
                                        </span>
                                    </div>
                                    <div className="col-12">
                                        <span className="p-float-label cdm-float-label">
                                            <InputText name="email" id="email" type="text" value={localUserState.get().email ?? ''} onChange={(e) => onChange(e)} size={25} className={classNames({
                                                "cdm-field-error": checkMail() || mailInUse,
                                            }, "cdm-tour-email")} />
                                            <label htmlFor="email">{I18n.get("eMail")}</label>
                                        </span>
                                        {mailInUse && (<small id="email-help" className="p-error block">{I18n.get("Email déjà utilisé")}</small>)}
                                    </div>
                                    <div className="col-12">
                                        <span className="p-float-label cdm-float-label">
                                            <InputText
                                                name="phone_number"
                                                id="phone_number"
                                                type="text"
                                                value={localUserState.get().phone_number ?? ''}
                                                onChange={(e) => onChange(e)}
                                                size={25}
                                                className={classNames({
                                                    "cdm-field-error": (checkPhoneNumber(localUserState.get().phone_number)),
                                                })}
                                                placeholder="+352123456"
                                            />
                                            <label htmlFor="phone_number">{I18n.get("phone_number")}</label>
                                        </span>
                                        {checkPhoneNumber(localUserState.get().phone_number) && (
                                            <small id="phone-help" className="p-error block pt-2">{I18n.get("invalideFormat")}</small>
                                        )}
                                    </div>
                                    <div className="col-12">
                                        <Dropdown value={localUserState.get().locale || 'FR'} options={[{ label: I18n.get('Allemand'), value: 'DE' }, { label: I18n.get('Français'), value: 'FR' }]} onChange={(e) => onChange(e)} name="locale" />
                                    </div>
                                    <div className="col-12">
                                        <Button
                                            onClick={handleSubmit}
                                            disabled={!localUserState.get().given_name || !localUserState.get().family_name || checkMail()}
                                            label={I18n.get("Sauvegarder")}
                                            className="p-button-success"
                                        />
                                    </div>
                                </div>
                            </TabPanel>
                            {(useGroupMember(['gerants', 'delegue'])) && (<TabPanel header={I18n.get("Equipe")} leftIcon="pi pi-users cdm-icon-tab" headerTemplate={tabHeaderTeam}>
                                <Team />
                            </TabPanel>)}
                        </TabView>
                    </div>
                </div>
            </div>
        </div>
    );
}